export default {
    title: "Encomenda em nome de",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Por favor, preencha o nome de usuário ou o e-mail",
            notFound: "Usuários não encontrados",
            errors: {
                myself: "O endereço de e-mail deve ser diferente do seu"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Enviar",
            processing: "Submissão"
        }
    },
    error: {
        userNotExists: "{email} não existe",
        country: {
            default: "DXC O equipamento está atualmente indisponível no país do usuário.",
            BRA: "DXC Os equipamentos estão temporariamente indisponíveis no Brasil."
        }
    }
}